import styled from 'styled-components';

export default styled.a`
  text-decoration: none;
  color: ${process.env.REACT_APP_COLOR_RC_ACTIONS};
  font-weight: bold;
  display: block;
  text-align: center;
  padding: 21px 0;
  font-size: 15px;
`;
